module.exports = function (angularModule) {
  angularModule.factory('listingStatsService', function () {
    const category = {
      SEARCH: 'SEARCH',
      UPDATE: 'UPDATE',
    };
    const dataType = {
      AVERAGE: 'AVERAGE',
      PERCENT: 'PERCENT',
      CATEGORIES: 'CATEGORIES',
      SUM: 'SUM',
    };
    const columns = [
      {
        id: 'totalListings',
        label: 'Total Listings Collected',
        hint: 'Total number of listings collected over the time period. The higher this number is, the more realistic the other statistics are',
        category: category.SEARCH,
        dataType: dataType.SUM
      },
      {
        id: 'ratioNumberOfListingsScrapedNonZero',
        label: '% Jobs Found Listings',
        hint: 'The closer this number is to 100%, the better. If the number is too low, it suggests that the search function is not broad enough',
        category: category.SEARCH,
        dataType: dataType.PERCENT
      },
      {
        id: 'ratioNumberOfMatchingListingsScrapedNonZero',
        label: '% Jobs Found Matching Listing',
        hint: 'The closer this number is to 100%, the better. If the number is too low, it suggests that the search function is not broad enough',
        category: category.SEARCH,
        dataType: dataType.PERCENT
      },
      {
        id: 'averageNumberOfListingsScraped',
        label: 'Avg. # Listings Found',
        hint: 'Average number of listings collected during a job. If this number is too high, server resources are being wasted. But if this number is too low, listing matches being found is less likely.',
        category: category.SEARCH,
        dataType: dataType.AVERAGE
      },
      {
        id: 'averageNumberOfMatchingListingsScrape',
        label: 'Avg. # Listing Matches Found',
        hint: 'Average number of listings that are found that Chatmeter is confident is the location. This number includes any duplicate listings found for a location.',
        category: category.SEARCH,
        dataType: dataType.AVERAGE
      },
      {
        id: 'successfulSearchTerms',
        label: 'Useful Search Terms',
        hint: 'Search terms that found the most matches during a search',
        category: category.SEARCH,
        dataType: dataType.CATEGORIES
      },
      {
        id: 'ratioExistingListingsFound',
        label: '% Existing Listings Found',
        hint: 'The closer this number is to 100%, the better. If it drops too low, it\'s a sign that the integration is broken.',
        category: category.UPDATE,
        dataType: dataType.PERCENT
      },
      {
        id: 'averageNumberOfNewListingsFound',
        label: 'Avg. Additional Listings Found',
        hint: 'Average number of listings of new listings found when refreshing a location\'s data. If this number is high, it indicates that either the listing search function yields inconsistent results, or that url structures have changed and existing listings are not being linked back to the search results',
        category: category.UPDATE,
        dataType: dataType.AVERAGE
      },
      {
        id: 'ratioFoundPrimaryListing',
        label: '% Jobs Found Primary Listing',
        hint: 'The closer this number is to 100%, the better. If it drops too low, it\'s a sign that the integration is broken.',
        category: category.UPDATE,
        dataType: dataType.PERCENT
      },
      {
        id: 'ratioPrimaryListingChanged',
        label: '% Jobs Primary Listing Switched',
        hint: 'The closer this number is to 0%, the better. If this number is too high, it suggests some kind of volatility in the provider or the Chatmeter engine.',
        category: category.UPDATE,
        dataType: dataType.PERCENT
      },
      {
        id: 'ratioListingsUpdated',
        label: '% Listings Had Any Field Updated',
        hint: 'If this number is abnormally high, it may suggest that the integration is broken and overwriting listing fields with incorrect data, or that the integration was recently fixed, and is rewriting correct data.',
        category: category.UPDATE,
        dataType: dataType.PERCENT
      },
      {
        id: 'averageNumberOfFieldsUpdated',
        label: 'Avg. # Fields Updated',
        hint: 'If this number is abnormally high, it may suggest that the integration is broken and overwriting listing fields with incorrect data, or that the integration was recently fixed, and is rewriting correct data.',
        category: category.UPDATE,
        dataType: dataType.AVERAGE
      },
    ];
    return {
      category,
      dataType,
      columns,
      searchColumns: () => columns.filter((e) => e.category === category.SEARCH),
      updateColumns: () => columns.filter((e) => e.category === category.UPDATE),

    }
  });
};
